import React from 'react';
import { Link } from 'react-router-dom';

function TermsOfService() {
  return (
    <div className="h-screen overflow-y-auto bg-gradient-to-br from-orange-50 via-white to-amber-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-sm border-b border-orange-100 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <img src="/eddy_logo.png" alt="Eddy" className="h-8 w-auto" />
            <span className="text-xl font-semibold text-gray-800">Eddy</span>
          </Link>
          <Link 
            to="/" 
            className="text-orange-600 hover:text-orange-700 font-medium transition-colors"
          >
            Zurück zur App
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-lg shadow-orange-100/50 border border-orange-100 p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Nutzungsbedingungen „Eddy" (Beta)
          </h1>

          {/* Impressum */}
          <div className="mb-8 p-4 bg-gray-50 rounded-lg">
            <h2 className="text-lg font-bold text-gray-800 mb-3">Anbieter / Impressum</h2>
            <div className="text-gray-600 space-y-3">
              <div>
                <p className="font-semibold">PC‑COLLEGE Training GmbH – Institut für IT‑Training</p>
                <p>Stresemannstr. 78, 10963 Berlin</p>
                <p>Geschäftsführer: Alain B. Barthel</p>
                <p>Handelsregister: HRB 173012 B, Amtsgericht Charlottenburg</p>
              </div>
              <div>
                <p className="font-semibold">Educas Weiterbildungs GmbH</p>
                <p>Bayerstr. 21, 80335 München</p>
                <p>Geschäftsführer: Dr. Thomas Fink, Dr. Arne Kues, Luis Rattenhuber, Dr. Thomas C. Sittel</p>
                <p>Handelsregister: Amtsgericht München, HRB 281097</p>
              </div>
              <p className="italic">Im folgenden als „Anbieter" gekennzeichnet.</p>
            </div>
          </div>

          <div className="prose prose-gray max-w-none space-y-8">
            
            {/* Section 1 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">1. Geltungsbereich, Vertragsgegenstand, Beta‑Status</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                1.1 Diese Nutzungsbedingungen regeln die unentgeltliche Nutzung der webbasierten KI‑Plattform <strong>„Eddy"</strong> durch Kursteilnehmende.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                1.2 <strong>Eddy (Beta)</strong> stellt KI‑gestützte Antworten zu Kursinhalten bereit und generiert beispielhafte Aufgaben, die sich am vom Nutzer angegebenen beruflichen Umfeld orientieren (z. B. Branche der Teilnehmenden).
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                1.3 <strong>Beta/Test‑Version.</strong> Der Dienst befindet sich in einer Erprobungsphase. Die Anbieter können den Dienst jederzeit ändern, einschränken oder einstellen. Es besteht kein Anspruch auf Verfügbarkeit, Funktionsumfang oder dauerhafte Nutzung. Der Dienst wird zu Evaluierungs- und Lernzwecken bereitgestellt und ist kein finales Produkt. Funktionsumfang, Qualität und Verfügbarkeit können vom späteren Produkt abweichen. Für „Eddy" bestehen keine Zusagen zu Verfügbarkeit, Reaktionszeit, Funktionsumfang, Fehlerfreiheit oder Eignung für bestimmte Zwecke. Der Dienst kann vorübergehend oder dauerhaft unterbrochen sein; Wartungs- und Testmaßnahmen können jederzeit stattfinden. Die Anbieter sind berechtigt, „Eddy" jederzeit zu ändern, einzuschränken oder einzustellen, einschließlich der vorzeitigen Beendigung einzelner Funktionen oder der gesamten Bereitstellung – auch ohne Ankündigung. Ergebnisse können unvollständig oder fehlerhaft sein. Sie eignen sich nicht als alleinige Grundlage für rechtlich oder wirtschaftlich bedeutsame Entscheidungen. Nutzer müssen Inhalte eigenverantwortlich prüfen und bleiben für deren Einsatz verantwortlich.
              </p>
              <p className="text-gray-600 leading-relaxed">
                1.4 <strong>Zustandekommen des Nutzungsvertrags.</strong> Die Nutzung von „Eddy" setzt einen bestehenden Schulungsvertrag voraus. Ein eigenständiger entgeltlicher Vertrag über „Eddy" kommt nicht zustande; „Eddy" wird als unentgeltliche Zusatzleistung zum jeweiligen Kurs bereitgestellt. Der Nutzungsvertrag über „Eddy" kommt zustande, indem die Anbieter dem Kursteilnehmer einen Zugang zu „Eddy" bereitstellen und sich der Kursteilnehmer für den Dienst „Eddy" anmeldet. Mit der erstmaligen Nutzung erkennt der Kursteilnehmer diese Nutzungsbedingungen als verbindlich an.
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">2. Zugang, Nutzungsdauer und Kosten</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                2.1 <strong>Zugangsdaten</strong> werden den Teilnehmenden mit Kursantritt zur Verfügung gestellt. Der Zugang ist persönlich und nicht übertragbar; Zugangsdaten sind vertraulich zu behandeln.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                2.2 <strong>Nutzungsfenster:</strong> Die unentgeltliche Nutzung ist auf einen Monat ab Freischaltung beschränkt. Die Anbieter können den Zeitraum aus Beta‑Gründen nach eigenem Ermessen verkürzen oder den Zugang widerrufen.
              </p>
              <p className="text-gray-600 leading-relaxed">
                2.3 Der Dienst ist für berechtigte Teilnehmende kostenlos. Für Hardware, Internetzugang und ggf. Drittkosten ist der Nutzer selbst verantwortlich.
              </p>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">3. Leistungsbeschreibung und Quellen</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                3.1 <strong>Quellenbasis:</strong> Eddy nutzt ausschließlich Kursmaterialien der Anbieter; keine Websuche und keine externen Inhalte/Quellen.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                3.2 <strong>Nutzungszweck:</strong> Der Dienst dient ausschließlich der fachlichen Nachbereitung/Vertiefung im jeweiligen Kurskontext. Fachfremde Inhalte oder Inhalte, welche über den gebuchten Kurs hinausgehen, werden nicht behandelt. Der Dienst darf nicht zur Vergabe von Noten, Punkten oder Zertifikaten, zur Entscheidung über Zugang/Zulassung zu Kursen oder Prüfungen oder zur Überwachung von Prüfungen eingesetzt werden. Entscheidungen über Leistungsbewertungen dürfen nicht allein oder überwiegend auf KI-Ausgaben von „Eddy" beruhen.
              </p>
              <p className="text-gray-600 leading-relaxed">
                3.3 <strong>Personalisierung:</strong> Zur Kontextualisierung kann der Nutzer freiwillig Angaben zu Branche, Rolle, Vorwissen etc. machen; daraus ergeben sich individualisierte Beispiele/Übungen (vgl. § 11 zu Betriebs-/Protokolldaten; Datenschutz separat).
              </p>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">4. Nutzungsrechte, Inhalte und Ergebnisse (Input/Output)</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                4.1 <strong>Eingaben (Input):</strong> Rechte an Nutzer‑Eingaben verbleiben beim Nutzer. Der Nutzer räumt den Anbietern eine einfache, nicht‑exklusive, unentgeltliche Lizenz ein, die Eingaben zum Betrieb des Dienstes in der Beta zu verarbeiten (z. B. Generierung von Antworten/Übungen, Systemsicherheit).
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                4.2 <strong>Ausgaben (Output):</strong> Der Nutzer erhält an den von Eddy erzeugten Inhalten eine einfache Nutzungsbefugnis für Lern‑ und arbeitsbezogene Zwecke im Kurskontext. Keine Gewähr für Richtigkeit/Vollständigkeit (vgl. § 9).
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                4.3 <strong>Nicht‑Exklusivität:</strong> KI‑Generierungen können ähnlich ausfallen und sich zwischen Nutzern überschneiden – dies ist systemimmanent.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                4.4 <strong>Kennzeichnungspflichten/Transparenz:</strong> Der Nutzer wird klar und erkennbar darüber informiert, dass er mit einem KI‑System interagiert; entsprechende Hinweise werden zum Zeitpunkt der ersten Interaktion bereitgestellt (Transparenzpflichten nach dem EU‑AI‑Act, Art. 50).
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                4.5 <strong>Widerrufsrecht:</strong> Eddy (Beta) wird den Kursteilnehmenden als unentgeltliche Zusatzleistung im Rahmen des bestehenden Schulungsvertrags zur Verfügung gestellt. Für „Eddy" besteht daher kein eigenständiges Widerrufsrecht. Gesetzliche Widerrufs- oder Rücktrittsrechte im Hinblick auf den zugrunde liegenden Kursvertrag bleiben unberührt.
              </p>
              <p className="text-gray-600 leading-relaxed">
                4.6 <strong>Pflicht zur Bereitstellung von Daten:</strong> Die Bereitstellung der genannten Account- und Basisdaten (insbesondere Name, E-Mail-Adresse, Kurszuordnung) ist für die Nutzung von „Eddy" erforderlich, da wir Ihnen sonst keinen Zugang anlegen können (Vertragserfüllung). Ohne diese Daten ist eine Nutzung von „Eddy" nicht möglich. Freiwillige Angaben (z. B. Branche, Rolle, Vorkenntnisse) müssen Sie nicht machen. Wenn Sie diese Angaben weglassen, erhalten Sie lediglich weniger personalisierte Inhalte; die Grundfunktion von „Eddy" bleibt nutzbar.
              </p>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">5. Schutz der Kursmaterialien</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                5.1 Alle <strong>Kursunterlagen</strong> (Texte, Aufgaben, Folien, Medien, Datenbanken, Prompt‑Vorlagen u. Ä.) sowie die Bezeichnung „Eddy" und Marken/Logos der Anbieter sind urheber‑/kennzeichenrechtlich geschützt.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                5.2 Untersagt sind Weitergabe, Re‑Upload und kommerzielle Nutzung der Kursunterlagen bzw. hieraus abgeleiteter Inhalte außerhalb des Kurskontexts.
              </p>
              <p className="text-gray-600 leading-relaxed">
                5.3 <strong>Technische Schutzmaßnahmen</strong> (z. B. Rate‑Limits, Download‑Sperren) dürfen nicht umgangen werden.
              </p>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">6. Pflichten der Nutzer</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                6.1 <strong>Zweckbindung:</strong> Nutzung nur im Rahmen des jeweiligen Kurses zu Fachthemen.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                6.2 <strong>Verbotene Nutzungen</strong> (Ausschnitt):
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4 mb-3">
                <li>Rechtsverstöße jeder Art; Verletzung von Urheber‑, Marken‑, Persönlichkeits‑, Datenschutz‑ oder Geschäftsgeheimnisrechten.</li>
                <li>Malware, Sicherheitsumgehung, Penetrationstests ohne ausdrückliche Erlaubnis, automatisiertes Scraping oder massenhafte Extraktion; Umgehung von Rate‑Limits; Reverse Engineering des Systems.</li>
                <li>Inhalte mit Gewaltverherrlichung, Terrorismus, Ausbeutung Minderjähriger, Hass/Belästigung, sowie Unterstützung von Waffen/Sprengstoff oder Schadsoftware‑Entwicklung.</li>
                <li><strong>Irreführung</strong> über den Ursprung von KI‑Inhalten; insbesondere ist KI‑Output nicht als ausschließlich menschlich erzeugt auszugeben, wenn dies nicht zutrifft.</li>
              </ul>
              <p className="text-gray-600 leading-relaxed">
                6.3 <strong>Moderation/Sanktionen:</strong> Bei Verstößen können Inhalte entfernt, Sicherheitsprofile verschärft, Zugänge vorübergehend oder dauerhaft gesperrt werden – abgestuft nach Schwere und Wiederholung (branchenübliche Eskalation).
              </p>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">7. Verfügbarkeit, Änderungen, Wartung</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                7.1 <strong>Kein SLA.</strong> Für den Beta‑Dienst werden keine Verfügbarkeitszusagen gemacht.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                7.2 <strong>Änderungen/Einstellung:</strong> Die Anbieter können den Dienst jederzeit ändern, Funktionen hinzufügen/entfernen oder den Betrieb einstellen (vgl. § 1.3).
              </p>
              <p className="text-gray-600 leading-relaxed">
                7.3 <strong>Wartungsfenster</strong> können zu Unterbrechungen führen; Notfall‑Wartungen sind jederzeit möglich.
              </p>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">8. Support</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                8.1 <strong>Self‑Service</strong> über Hilfetexte/FAQ.
              </p>
              <p className="text-gray-600 leading-relaxed">
                8.2 Mitarbeitende der Anbieter haben keinen routinemäßigen Zugriff auf individuelle Chatverläufe. Ein Zugriff auf Inhalte erfolgt nur in eng begrenzten Ausnahmefällen, soweit dies rechtlich zulässig und erforderlich ist (z. B. zur Analyse schwerwiegender Sicherheitsvorfälle, zur Behebung gravierender technischer Fehler oder zur Erfüllung gesetzlicher Auskunfts- und Mitwirkungspflichten). Solche Zugriffe werden protokolliert und auf das notwendige Maß beschränkt.
              </p>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">9. Fachhinweise, Richtigkeitsvorbehalt</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                9.1 <strong>Kein Ersatz für Fachberatung.</strong> KI‑Ausgaben können unvollständig, fehlerhaft oder unangemessen sein und stellen keine Rechts‑, Steuer‑, Medizin‑ oder sonstige Fachberatung dar. Nutzer müssen menschliche Prüfung vor Nutzung/Weitergabe vornehmen.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                9.2 <strong>Kontextbeschränkung:</strong> Eddy deckt nur Kursinhalte ab; fachfremde Fragen werden abgewiesen.
              </p>
              <p className="text-gray-600 leading-relaxed">
                9.3 <strong>Labeling‑Pflichten</strong> für generierte Inhalte, die öffentlich verbreitet oder im beruflichen Kontext genutzt werden, bleiben unberührt (Transparenz nach EU‑AI‑Act).
              </p>
            </section>

            {/* Section 10 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">10. Sicherheit & Infrastruktur</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                10.1 <strong>Sicherheitsmaßnahmen:</strong> PC‑COLLEGE und Educas Weiterbildungs GmbH setzen angemessene technische und organisatorische Maßnahmen ein; der Beta‑Status kann jedoch Risiken erhöhen (z. B. Datenverlust, Fehlfunktionen) – typische Preview‑Einschränkungen gelten. Es werden TLS-Verschlüsselung für Daten während der Übertragung verwendet. Azure DB verwendet standardmäßig Verschlüsselung im Ruhezustand. Zugriffs- und Systemereignisse (z. B. Fehler, administrative Aktionen) werden protokolliert, um Missbrauch zu erkennen, Probleme zu beheben und die Sicherheit zu verbessern. Es werden keine sensiblen Daten protokolliert.
              </p>
              <p className="text-gray-600 leading-relaxed">
                10.2 <strong>Barrierefreiheit:</strong> Die Anbieter arbeiten an einer zugänglichen Gestaltung; gesetzlich geforderte Transparenzhinweise werden klar und unterscheidbar bereitgestellt.
              </p>
            </section>

            {/* Section 11 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">11. Betriebs- und Protokolldaten</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                11.1 <strong>Protokollierung:</strong> Zur Sicherstellung von Betrieb/Sicherheit werden Nutzungs‑ und Systemprotokolle geführt (z. B. Zeitstempel, Fehlermeldungen, technische Kennungen) und aufbewahrt.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                11.2 <strong>Keine Trainingsnutzung:</strong> <strong>Nutzerinhalte</strong> werden nicht zum Training der zugrundeliegenden KI‑Modelle verwendet. Anonymisierte Auswertungen können für Qualitätssicherung/Statistiken erfolgen.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                11.3 <strong>Löschung:</strong> <strong>Accounts und Nutzerinhalte</strong> werden spätestens 12 Monate nach Kursende anonymisiert oder gelöscht.
              </p>
              <p className="text-gray-600 leading-relaxed">
                11.4 <strong>Cookies:</strong> Auf der Website kommen nur technisch notwendige Cookies zum Einsatz; es werden keine weiteren Cookies erfasst und gespeichert.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4 p-3 bg-orange-50 rounded-lg border border-orange-200">
                <strong>Hinweis:</strong> Detaillierte Informationen nach Art. 13/14 DSGVO (Zwecke, Rechtsgrundlagen, Empfänger, Drittlandtransfers, Betroffenenrechte etc.) folgen in einer separaten <Link to="/privacy-policy" className="text-orange-600 hover:text-orange-700 underline">Datenschutzerklärung</Link>.
              </p>
            </section>

            {/* Section 12 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">12. Laufzeit und Beendigung</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                12.1 Der Vertrag beginnt mit Freischaltung und endet automatisch nach einem Monat.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                12.2 <strong>Außerordentliche Beendigung:</strong> Die Anbieter können den Zugang jederzeit sperren/kündigen (z. B. aufgrund von AUP‑Verstoß, Sicherheitsrisiken, Missbrauch, rechtliche Verpflichtung).
              </p>
              <p className="text-gray-600 leading-relaxed">
                12.3 Nach Beendigung erlischt der Zugang; Nutzungsrechte an Outputs bleiben für bereits erzeugte Inhalte im Rahmen von § 4.2 bestehen.
              </p>
            </section>

            {/* Section 13 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">13. Haftung</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                13.1 Unbeschränkt haften die Anbieter bei Vorsatz und grober Fahrlässigkeit sowie für Schäden aus der Verletzung von Leben, Körper oder Gesundheit.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                13.2 Bei leichter Fahrlässigkeit haften die Anbieter nur bei Verletzung wesentlicher Vertragspflichten („Kardinalpflichten") – und beschränkt auf den vorhersehbaren, typischen Schaden.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                13.3 Im Übrigen ist die Haftung ausgeschlossen; Produkthaftung bleibt unberührt.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                13.4 Diese Haftungsregelung entspricht den Vorgaben der §§ 305 ff., 307–309 BGB (insb. § 309 Nr. 7 BGB) zur AGB‑Wirksamkeit von Haftungsbeschränkungen.
              </p>
              <p className="text-gray-600 leading-relaxed">
                13.5 <strong>Beta‑Hinweis:</strong> Für Beta‑/Preview‑Funktionen bestehen keine Beschaffenheits‑/Verfügbarkeitszusagen; Datenverlust/Fehler können auftreten.
              </p>
            </section>

            {/* Section 14 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">14. Mitwirkungspflichten; Meldung von Problemen</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                14.1 Nutzer prüfen kritisch die Outputs vor Nutzung/Weitergabe (§ 9).
              </p>
              <p className="text-gray-600 leading-relaxed">
                14.2 Sicherheitsvorfälle, Missbrauch oder policy‑widrige Inhalte sind unverzüglich zu melden (Kontakt siehe § 18).
              </p>
            </section>

            {/* Section 15 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">15. Änderungen dieser Bedingungen</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                15.1 Die Anbieter können diese Bedingungen anpassen (z. B. bei Gesetzesänderungen oder Produktänderungen).
              </p>
              <p className="text-gray-600 leading-relaxed">
                15.2 Wesentliche Änderungen werden vorab auf der Eddy-Website oder per E‑Mail bekanntgegeben; die Nutzung nach Wirksamwerden gilt als Zustimmung.
              </p>
            </section>

            {/* Section 16 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">16. Anwendbares Recht und Gerichtsstand</h2>
              <p className="text-gray-600 leading-relaxed mb-3">
                16.1 Es gilt deutsches Recht; zwingende Verbraucherschutzvorschriften des Wohnsitzstaats bleiben unberührt.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                16.2 Ist der Nutzer Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen, ist ausschließlicher Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit diesen Nutzungsbedingungen Berlin; zuständiges Gericht ist das Amtsgericht Charlottenburg bzw. bei Überschreitung der Wertgrenzen das Landgericht Berlin.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3">
                16.3 Für Nutzer, die Verbraucher sind, gelten die gesetzlichen Gerichtsstandsregelungen.
              </p>
              <p className="text-gray-600 leading-relaxed">
                16.4 <strong>Online-Streitbeilegung.</strong> Die Anbieter sind weder verpflichtet noch bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle im Sinne des Verbraucherstreitbeilegungsgesetzes (VSBG) teilzunehmen.
              </p>
            </section>

            {/* Section 17 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">17. Salvatorische Klausel</h2>
              <p className="text-gray-600 leading-relaxed">
                Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen unberührt. An die Stelle der unwirksamen Regelung tritt – soweit rechtlich möglich – die gesetzliche Regelung.
              </p>
            </section>

            {/* Section 18 */}
            <section>
              <h2 className="text-xl font-bold text-gray-800 mb-4">18. Kontakt</h2>
              <div className="text-gray-600 space-y-3">
                <div>
                  <p className="font-semibold">PC‑COLLEGE Training GmbH – Institut für IT‑Training</p>
                  <p>Stresemannstr. 78, 10963 Berlin</p>
                  <p>E‑Mail: info@pc-college.de | Telefon: +49 (0)30 235 50 0</p>
                </div>
                <div>
                  <p className="font-semibold">Educas Weiterbildungs GmbH</p>
                  <p>Bayerstr. 21, 80335 München</p>
                  <p>E‑Mail: info@educas.de</p>
                </div>
              </div>
            </section>

          </div>
        </div>

        {/* Footer Link */}
        <div className="text-center mt-8">
          <Link 
            to="/privacy-policy" 
            className="text-orange-600 hover:text-orange-700 font-medium transition-colors"
          >
            Datenschutzerklärung ansehen →
          </Link>
        </div>
      </main>
    </div>
  );
}

export default TermsOfService;
